import type { PortableTextTypeComponent } from '@portabletext/react';
import groq from 'groq';

import type { LelandImage } from '../../../types/cmsTypes';
import SanityImage, { SANITY_IMAGE_PROJECTION } from '../../image/SanityImage';

const NOTE_TYPE = 'note';
export const NOTE_MARK_DEFS_SELECTION = groq`_type == "${NOTE_TYPE}" => {
  ...,
  image {${SANITY_IMAGE_PROJECTION}}
}`;

interface Props {
  _type: typeof NOTE_TYPE;
  text: string;
  image?: LelandImage;
  color: 'green' | 'grey';
}

const Note: PortableTextTypeComponent<Props> = ({
  value: { text, image, color } = {},
}) => {
  return (
    <div
      className={`mb-12 flex items-center rounded-xl p-4 lg:mb-20 ${
        color === 'grey'
          ? 'bg-leland-gray-hover'
          : 'bg-leland-primary-extra-light'
      }`}
    >
      {image ? (
        <div className="mr-2 w-6">
          <SanityImage image={image} alt="" sizes={{ dflt: '0.5rem' }} />
        </div>
      ) : null}
      <p
        className={
          color === 'grey' ? 'text-leland-gray-dark' : 'text-leland-primary'
        }
      >
        {text}
      </p>
    </div>
  );
};

export default Note;

export const NoteHtml: PortableTextTypeComponent<Props> = ({
  value: { text, image, color } = {},
}) => {
  return (
    <div
      className={`mb-12 flex items-center rounded-xl p-4 lg:mb-20 ${
        color === 'grey'
          ? 'bg-leland-gray-hover'
          : 'bg-leland-primary-extra-light'
      }`}
    >
      {image ? (
        <div className="mr-2 w-6">
          <img src={image.asset.url} alt="" />
        </div>
      ) : null}
      <p
        className={
          color === 'grey' ? 'text-leland-gray-dark' : 'text-leland-primary'
        }
      >
        {text}
      </p>
    </div>
  );
};
